<template>
  <div>
    <btc-nav-bar :items="items" :is-en-expire="isEnExpire" @handle-navbar="handleNavBar"/>
    <div class="item-box">
      <btc-chart v-if="list" ref="liveCattleChart" :data="chartData" :title='title' :color="chartColor" :legend="legend" :y-axis-name="yAxisName" :is-en-expire="isEnExpire" @getChartX="getDateAndPrice"/>
      <div class="item-box" style="padding: 30px;">
        <btc-table :country="country" :tableList="tableList" :items="tableHeader"/>
      </div>
    </div>
  </div>
</template>

<script>
import BtcTable from './components/table/live-cattle'
import BtcChart from './components/chart'
import BtcNavBar from './components/navbar'
import commonmix from '@/utils/commonmix'
import { getLocalStore } from '@/utils/common'

export default {
  mixins: [commonmix],
  name: 'ExportsToChina',
  components: {
    BtcTable,
    BtcChart,
    BtcNavBar
  },
  data () {
    return {
      items: [
        { label: 'United States', value: '美国' },
        { label: 'Brazil', value: '巴西' },
        { label: 'Australia', value: '澳大利亚' },
        { label: 'Uruguay', value: '乌拉圭' },
        { label: 'Argentina', value: '阿根廷' }
      ],
      tableHeader: [
        { label: 'Date', icon: require('@/assets/image/price/Date.png') },
        { label: 'Currency', icon: require('@/assets/image/price/currency.png') },
        { label: 'Trend', icon: require('@/assets/image/price/Trend.png') }
      ],
      tableList: [],
      chartData: {},
      chartColor: { Color1: '#3877f2', Color2: '#FFFFFF' },
      legend: {
        orient: 'vertical',
        icon: 'roundRect',
        itemWidth: 10,
        itemHeight: 10,
        right: 100,
        top: 15,
        selectedMode: false
      },
      country: '美国',
      yAxisName: '',
      title: 'United States Live Cattle Price in Live Weight',
      list: null
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    isEnExpire () {
      return this.getUserProfile(this.$t('message._beefprice_en'))
    }
  },
  methods: {
    getData () {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetWebPriceLivecattleIndex', {
        UserID: getLocalStore().UserID,
        Country: this.country,
        isEn: true
      }).then(() => {
        this.list = this.$store.getters.priceRow
        this.riseList = this.list.riseList
        this.chartData = { categories: this.list.categories, series: this.getSeries(this.list.series) }
        if (this.$refs.liveCattleChart) {
          this.$refs.liveCattleChart.refreshData({ categories: this.list.categories, series: this.getSeries(this.list.series) })
        }
        this.getDateAndPrice(this.list.categories.slice(-1)[0])
        this.$store.dispatch('SetLoadingStatus', false)
      }).catch((err) => {
        console.error(err)
        this.$store.dispatch('SetLoadingStatus', false)
      })
    },
    getDateAndPrice (category) {
      const rise = []
      for (let i = 0; i < this.list.series.length; i++) {
        const item = this.list.series[i]
        if (item.data && item.data.length > 0) {
          for (let i = 0; i < this.riseList.length; i++) {
            const end = this.riseList[i][0].key.indexOf('-')
            const key = this.riseList[i][0].key.substring(0, end)
            if (key === item.name) {
              const riseFilterList = this.riseList[i].filter(v => {
                return v.key === item.name + '-' + category
              })
              if (riseFilterList.length) {
                rise.push(this.riseList[i].filter(v => {
                  return v.key === item.name + '-' + category
                }).map(v => {
                  return { date: category, category: item.name, currency: item.data[this.list.categories.indexOf(category)], trend: v.rise }
                })[0])
              } else {
                rise.push({ date: category, category: item.name, currency: item.data[this.list.categories.indexOf(category)] ? item.data[this.list.categories.indexOf(category)] : '--', trend: '--' })
              }
            }
          }
        }
      }
      this.tableList = rise
    },
    handleNavBar (item) {
      this.country = item.value
      this.handleTableHeader()
      this.handleTitle()
      this.getData()
    },
    getSeries (data) {
      return data.map(v => {
        v.type = 'line'
        return v
      })
    },
    handleTableHeader () {
      switch (this.country) {
        case '巴西':
          this.tableHeader = [
            { label: 'Date', icon: require('@/assets/image/price/Date.png') },
            { label: 'Currency', icon: require('@/assets/image/price/currency.png') },
            { label: 'Trend', icon: require('@/assets/image/price/Trend.png') }
          ]
          this.title = 'Brazilian Live Cattle Price in Carcass Weight'
          break
        case '澳大利亚':
        case '乌拉圭':
        case '阿根廷':
          this.tableHeader = [
            { label: 'Date', icon: require('@/assets/image/price/Date.png') },
            { label: 'Category', icon: require('@/assets/image/price/category.png') },
            { label: 'USD/kg', icon: require('@/assets/image/price/USD.png') },
            { label: 'Trend', icon: require('@/assets/image/price/Trend.png') }
          ]
          break
        case '美国':
          this.tableHeader = [
            { label: 'Date', icon: require('@/assets/image/price/Date.png') },
            { label: 'USD/kg', icon: require('@/assets/image/price/USD.png') },
            { label: 'Trend', icon: require('@/assets/image/price/Trend.png') }
          ]
          break
        default:
          return []
      }
    },
    handleTitle () {
      switch (this.country) {
        case '巴西':
          this.yAxisName = ''
          this.title = 'Brazilian Live Cattle Price in Carcass Weight'
          break
        case '澳大利亚':
          this.yAxisName = 'USD/kg lwt'
          this.title = 'Australian Live Cattle Price in Live Weight'
          break
        case '乌拉圭':
          this.yAxisName = 'USD/kg lwt'
          this.title = 'Uruguayan Live Cattle Price in Live Weight'
          break
        case '阿根廷':
          this.yAxisName = 'USD/kg lwt'
          this.title = 'Argentine Live Cattle Price in Live Weight'
          break
        case '美国':
          this.yAxisName = ''
          this.title = 'United States Live Cattle Price in Live Weight'
          break
        default:
          this.yAxisName = ''
          return 'Brazilian Live Cattle Price in Carcass Weight'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-box {
  min-height: 420px;
  margin: 20px;
  padding-top: 20px;
  border-radius: 20px;
  background-color: #ffffff;
}

// 筛选
.selector-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.selector-left {
  display: flex;
  justify-content: space-between;
}
</style>
